import { get, patch, put } from 'api';
import queryClient from 'query-client';
import { MutationOptions } from 'hooks/types';
import { IGetLiveClass } from 'types/liveClass';
import { GenericAPIResponse } from 'types/generic';
import { QueryOptions, useMutation, useQuery } from 'react-query';
import { IBasicSession, IGetSession, IGetSessionList } from 'types/basicSession';

export const useSessionList = (options?: QueryOptions<IGetSessionList>) => {
  return useQuery<IGetSessionList, any>(['sessions/session-list'], () => get('basic_sessions'), {
    ...(options || {}),
    cacheTime: 0,
    retry: false,
  });
};

export const useSessionQuery = (id: string, options?: QueryOptions<IGetSession>) => {
  return useQuery<IGetSession, any>(['sessions/session', id], () => get(`basic_sessions/${id}`), {
    ...(options || {}),
    cacheTime: 0,
    retry: false,
  });
};

export const useUpdateSessionMutation = (
  id: string,
  options?: MutationOptions<GenericAPIResponse<IBasicSession>>,
) => {
  return useMutation((value: IBasicSession) => put(`basic_sessions/${id}`, value), {
    ...(options || {}),
  });
};

export const useMarkSessionCompleteMutation = (options?: QueryOptions<IGetSession>) => {
  return useMutation<IGetSession, any, string>(
    (id: string) => patch(`basic_sessions/${id}/actions/complete`),
    {
      ...(options || {}),
      onSettled: () => {
        queryClient.invalidateQueries('sessions/session-list');
        queryClient.invalidateQueries(['sessions/session']);
      },
    },
  );
};
